import React, { useState } from "react";
import { Avatar } from "@mui/material";
import { KeyboardArrowDownRounded } from "@mui/icons-material";
import { useAppContext } from "context";
import Drawer from "../../layout/Drawer";
import Profile from "../../components/body/profile/Profile";
import LanguageSwitcher from "../../components/body/LanguageSwitcher";
import QuickCreate from "./QuickCreate";
import NotificationsMenu from "./NotificationsMenu";
import HelpMenu from "./HelpMenu";

/**
 * Tier-1 (light utility bar) right-hand cluster:
 * Quick Create · Notifications · Help · Language · Company/Outlet · User.
 */
const ModernHeaderActions = () => {
  const { authUser } = useAppContext();
  const [openProfile, setOpenProfile] = useState(false);

  return (
    <div className="flex items-center gap-1">
      <QuickCreate />
      <NotificationsMenu />
      <HelpMenu />
      <LanguageSwitcher light />

      {/* User identity → profile drawer */}
      <button
        type="button"
        onClick={() => setOpenProfile(true)}
        className="flex items-center gap-2 ps-2 ms-1 border-s border-slate-200 hover:bg-slate-50 rounded-lg py-1 px-1.5"
      >
        <Avatar
          alt="profile"
          src={authUser?.photo}
          sx={{ width: 32, height: 32, bgcolor: "var(--primary-color)", fontSize: 14 }}
        >
          {!authUser?.photo && (authUser?.fullName || "U").charAt(0).toUpperCase()}
        </Avatar>
        <div className="hidden md:flex flex-col items-start min-w-0 leading-tight">
          <span className="text-[13px] font-semibold text-slate-700 truncate max-w-[140px]">
            {authUser?.fullName}
          </span>
          {authUser?.userRole && (
            <span className="text-[11px] text-slate-400 truncate max-w-[140px]">
              {authUser.userRole}
            </span>
          )}
        </div>
        <KeyboardArrowDownRounded className="!text-[18px] text-slate-400" />
      </button>

      <Drawer open={openProfile} setOpen={setOpenProfile} topOffset={0}>
        <Profile setOpen={setOpenProfile} open={openProfile} />
      </Drawer>
    </div>
  );
};

export default ModernHeaderActions;
